import React from 'react';
import ReactDOM from 'react-dom';
// For IE 11 and Google crawler compatibility
import 'react-app-polyfill/ie11';
import 'es6-shim';
import 'es7-shim';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import ContentExporter from "./Exporter/ContentExporter";
import IPO from "./IpoReady/IpoReady";
 import SeriesA from "./SeriesAReady/SeriesAReady";
import LtScorecard from "./LtScorecard/LtScorecard";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

import './index.scss';

let isDebug;
if (window.URLSearchParams) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    isDebug = urlSearchParams.get("debug");
}

const isPresentingLTScorecard = window.location.pathname.includes("scorecard");
const headerinfo = process.env.REACT_APP_SELECTION_FLAG === "SeriesA" ? SeriesA : IPO;

const AppRouter = () => (
    <BrowserRouter>
        <div className="app">
            {/* TODO: 404 <Route component={NoMatch} /> */}
            <Header
                isDebug={!!isDebug}
                app={isPresentingLTScorecard ? LtScorecard : headerinfo}
            />
            <Routes>
            <Route exact path="/" element={process.env.REACT_APP_SELECTION_FLAG === "SeriesA" ? <SeriesA isDebug={!!isDebug} /> : <IPO isDebug={!!isDebug} />} />
            <Route exact path="/ipo" element={<IPO isDebug={!!isDebug} />} />
            <Route exact path="/seriesa" element={<SeriesA isDebug={!!isDebug} />} />
            <Route exact path="https://happy-mud-04ea99610.4.azurestaticapps.net" element={<IPO isDebug={!!isDebug} />} />
            <Route exact path="https://seriesaready.com" element={<SeriesA isDebug={!!isDebug} />} />

            <Route path="/content-exporter/" element={<ContentExporter />} />
            <Route path="/long-term-scorecard/" element={<LtScorecard />} />
            </Routes>
            <Footer
                app={isPresentingLTScorecard ? LtScorecard : headerinfo}
            />
        </div>
    </BrowserRouter>
);

ReactDOM.render(
    <AppRouter />,
    document.getElementById('root'),
);
